import React from "react";
import { Navbar } from "react-bootstrap";

// const styles = StyleSheet.create({
//   footer: {
//     /*position: absolute;*/
//     bottom: 0,
//     width: "100%",
//     padding: "10px 0px",
//     background: "#e3f3f3",
//     textalign: "center",
//   },
// });
const Footer = () => {
  return (
    <Navbar bg="light" style={{ padding: 0 }}>
      <div
        style={{
          height: "32px",
          width: "100%",
          color: "white",
          backgroundColor: "rgb(67 142 77)",
          textAlign: "center",
        }}
      >
        <span style={{ lineHeight: "32px" }}>
          {" "}
          v2.0.0 Copyright © 2025 All rights reserved. Designed by{" "}
        </span>
        <a
          style={{ color: "white", lineHeight: "32px", textDecoration: "none" }}
          href="https://www.vistaarintuitivesolution.com/"
          target="_blank"
          rel="noopener noreferrer"
          onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
          onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
        >
          Vistaar Intuitive Solution
        </a>
      </div>
    </Navbar>
  );
};

export default Footer;
